import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Landmark, MapPin, ScrollText } from 'lucide-react';

const TRUST = [
  { icon: ShieldCheck, label: 'SA Attorneys', hint: 'Reviewed by South African legal professionals' },
  { icon: Lock, label: 'Confidential', hint: 'POPIA-compliant handling of your information' },
  { icon: ScrollText, label: 'No Upfront Legal Fees', hint: 'Fee arrangements discussed openly (where applicable)' },
  { icon: MapPin, label: 'Nationwide Assistance', hint: 'All nine provinces of the Republic' },
  { icon: Landmark, label: 'Constitutional Focus', hint: 'Rooted in Sections 12 & 35 of the Constitution' },
];

export default function TrustBar({ testId = 'trust-bar' }) {
  return (
    <div data-testid={testId} className="relative border-y border-white/[0.06] bg-[#0a1524]/50">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-5 md:py-6">
        <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 md:gap-x-12">
          {TRUST.map((t, i) => (
            <motion.li
              key={t.label}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="group flex items-center gap-2.5"
              title={t.hint}
            >
              <t.icon className="h-4 w-4 md:h-[18px] md:w-[18px] text-[#39A8FF] group-hover:text-[#FFD400] transition-colors" strokeWidth={1.8} />
              <span className="font-inter text-[11px] md:text-[13px] font-semibold uppercase tracking-[0.14em] text-white/85">{t.label}</span>
            </motion.li>
          ))}
        </ul>
      </div>
    </div>
  );
}
